// src/pages/produtos/combos/ConjuntoItemCad.js
import { useEffect, useState } from 'react';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import { ConjuntoItem } from '../../../models/produtos/combos/ConjuntoItem';
import { useProduto } from '../../../contexts/produtos/ProdutoContext';
import Input from '../../../components/input/Input';
import { useConjuntoItem } from '../../../contexts/produtos/combos/ConjuntoItemContext';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';

const ConjuntoItemCad = ({ isOpen, onClose, conjuntoId, item = null }) => {
  const { produtos, showProdutoSearch } = useProduto();
  const [erros, setErros] = useState({});
  const [conjuntoItem, setConjuntoItem] = useState(new ConjuntoItem());
  const { addConjuntoItem, updateConjuntoItem } = useConjuntoItem();
  const emEdicao = !!item?.id;

  useEffect(() => {
    if (!isOpen) return;

    setConjuntoItem(item ? { ...item } : new ConjuntoItem());
    setErros({});
  }, [isOpen, item]);

  const validateForm = () => {
    const novosErros = {};

    if (!conjuntoItem.produtoId || isNaN(conjuntoItem.produtoId)) {
      novosErros.produtoId = 'Código do produto é obrigatório';
    }
    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      ...conjuntoItem,
      conjuntoId: conjuntoId,
    };
    delete payload.produto;
    delete payload.conjunto;

    if (emEdicao) {
      await updateConjuntoItem(payload);
    } else {
      await addConjuntoItem(payload);
    }

    onClose();
  };

  const handleBuscarProduto = async () => {
    const produtoSel = await showProdutoSearch();
    if (produtoSel) {      
      setConjuntoItem({
        ...conjuntoItem,
        produtoId: produtoSel.id,
        produto: produtoSel,
        valorAdicional: produtoSel.preco,
      });

      setErros((prev) => ({ ...prev, produtoId: '' }));
    }
  };

  const handleProdutoExit = () => {
    const produtoId = parseInt(conjuntoItem.produtoId);
    if (!produtoId || isNaN(produtoId)) {
      setConjuntoItem({ ...conjuntoItem, produtoId: null});
      return;
    }

    const selected = produtos.find((p) => p.id === produtoId);
    if (!selected) {
      setConjuntoItem({ ...conjuntoItem, produtoId: null });
      setErros((prev) => ({ ...prev, produtoId: 'Produto não encontrado' }));
      return;
    }

    setConjuntoItem({
      ...conjuntoItem,
      produtoId: selected.id,
      produto: selected, 
      valorAdicional: selected.preco,
    });

    setErros((prev) => ({ ...prev, produtoId: '' }));
  };

  if (!isOpen) return null;

  return (
    <ModalContainer show={isOpen} variant="cadastro" onHide={onClose}>
      <ModalHeader title={<>{emEdicao ? 'Alterar Item do Conjunto' : 'Incluir Item do Conjunto'}</>} onHide={onClose} />

      <ModalBody>
        <div className="input-group">
          <Input
            label="Cód. Produto"
            value={conjuntoItem.produtoId || ''}
            btnBuscar={handleBuscarProduto}
            onChange={(e) => {
              setConjuntoItem({ ...conjuntoItem, produtoId: e.target.value });
              setErros((prev) => ({ ...prev, produtoId: '' }));
            }}
            onBlur={handleProdutoExit}
            autoFocus
            msgErro={erros.produtoId}
          />
          <Input
            label="Descrição"
            value={conjuntoItem.produto?.descricao || ''}
            size={300}
            disabled
          />
          <Input
            label="Valor Adicional"
            value={conjuntoItem.valorAdicional || ''}
            onChange={(e) => setConjuntoItem({ ...conjuntoItem, valorAdicional: e.target.value })}
            size={100}
          />
          <Input
            label="Variacao"
            value={conjuntoItem.variacao || ''}
            onChange={(e) => setConjuntoItem({ ...conjuntoItem, variacao: e.target.value })}
            size={130}
          />
        </div>

      </ModalBody>

      <ModalFooter className="modal-footer flex-footer">
        <button className="btn btn-secondary" onClick={onClose}>
          Cancelar
        </button>
        <ModalActionButton className="btn btn-success" onClick={handleSubmit} action="save">
          Gravar
        </ModalActionButton>
      </ModalFooter>
    </ModalContainer>
  );
};

export default ConjuntoItemCad;
